import React from 'react';
import { useOnline } from '../../hooks/useOnline';
import './DisconnectedBanner.css';

/**
 * Top-of-chat banner that surfaces when the browser reports an offline
 * network. Auto-hides once connectivity returns.
 *
 * Rendering returns null while online so the banner has zero layout cost
 * during the happy path. The visual is a glass pill matching SystemBanner
 * tone with a CSS-only spinner; reduced-motion users get a static dot.
 */
function DisconnectedBanner() {
  const online = useOnline();
  if (online) return null;

  return (
    <div
      className="glacier-disconnected-banner"
      role="status"
      aria-live="polite"
      data-testid="disconnected-banner"
    >
      <span
        className="glacier-disconnected-banner__spinner"
        aria-hidden="true"
      />
      <span className="glacier-disconnected-banner__label">Reconnecting…</span>
    </div>
  );
}

export default DisconnectedBanner;
